import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    navOpen: false,
    activeProduct: null,
    searchQuery: '',
  },
  reducers: {
    toggleNav(state) {
      state.navOpen = !state.navOpen;
    },
    closeNav(state) {
      state.navOpen = false;
    },
    setActiveProduct(state, action) {
      state.activeProduct = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
  },
});

export const { toggleNav, closeNav, setActiveProduct, setSearchQuery } = uiSlice.actions;
export default uiSlice.reducer;
